import { Button } from "@material-tailwind/react";
import React, { useCallback, useEffect, useState } from "react";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { allInteractionsThreadsApi, allLikeDislikedThreadsApi, exportLikeDislikeInteractions, threadsResponseApi } from "../../api";
import Drawer from "react-modern-drawer";
import { RxCross2 } from "react-icons/rx";
import ShowInteractions from "./ShowInteractions";
import { delete_user_data_from_client_side } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import DatePeriodSelection from "./DatePeriodSelection";
import { errorToast } from "../../utils/toastNotify";
import { ErrorMessages, ErrorType } from "../../utils/constants";
import { ToastContainer } from "react-toastify";

export interface ShowThreadResponseProps {
    open: boolean;
    onCloseDialog: () => void;
    selectedThreadId: string;
    selectedIndex?: number;
    checkBoxValue?: string;
}
const ShowThreadResponse = ({ open, onCloseDialog, selectedThreadId, selectedIndex, checkBoxValue }: ShowThreadResponseProps) => {
    const size = window.innerWidth * 0.6;

    return (
        <Drawer
            open={open}
            onClose={onCloseDialog}
            direction="right"
            size={size}
            duration={1000}
            enableOverlay={true}
            className={`bg-gray-150 border-2 border-solid border-gray-400 mt-16 overflow-auto mb-10 scroll`}
        >
            <div className="">
                <div className="sticky top-0 flex z-10 w-full h-11 bg-white rounded-b-lg items-center">
                    <RxCross2 className="p-1 cursor-pointer items-start" size={36} onClick={onCloseDialog} />
                    <div className="font-bold w-full text-lg flex justify-center	text-green-800">
                        <strong>Interaction Id: </strong> &nbsp;
                        {selectedThreadId}
                    </div>
                </div>
                <div className="px-4">
                    <ShowInteractions
                        prompt={""}
                        response={""}
                        citations={""}
                        thread_id={selectedThreadId}
                        // selectedIndex={selectedIndex}
                        checkBoxValue={checkBoxValue}
                        from={"like&dislike"}
                    ></ShowInteractions>
                </div>
            </div>
        </Drawer>
    );
};
const DislikeInteractionsThread = ({ dislikeInteractionsData, open, setOpen, selectedRows, setSelectedRows, checkBoxValue, showUserIdCol }: any) => {
    const [selectedThreadId, setSelectedThreadId] = useState("");
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const onCellClicked = useCallback((params: any) => {
        setSelectedThreadId(params.data.interaction_id);
        setSelectedIndex(params.data.index);
        setIsDialogOpen(true);
        setOpen(true);
    }, []);
    const closeDrawerRight = () => {
        setIsDialogOpen(false);
        setOpen(false);
    };
    const calculateLikeDislikeRatio = useCallback(() => {
        const likeCount = dislikeInteractionsData.filter((item: any) => item.like_dislike === "good").length;
        const dislikeCount = dislikeInteractionsData.filter((item: any) => item.like_dislike === "bad").length;

        return {
            likeCount,
            dislikeCount,
            ratio: dislikeCount === 0 ? "N/A" : (likeCount / dislikeCount).toFixed(2) // Avoid divide by zero
        };
    }, [dislikeInteractionsData]);
    const [colDefs, setColDefs] = useState<ColDef<any>[]>([]);
    useEffect(() => {
        setColDefs(
            showUserIdCol
                ? [
                      { field: "timestamp", headerName: "Date & Time", minWidth: 220, flex: 1 },
                      { field: "id", headerName: "User ID", minWidth: 350, hide: false, flex: 1 }, // Show only if `showUserIdCol` is true
                      { field: "interaction_id", headerName: "Interaction Id", minWidth: 200, flex: 1 },
                      { field: "index", headerName: "Index", hide: true },
                      { field: "pm_power_user", headerName: "PM Power User", minWidth: 200, flex: 1, filter: false }
                  ]
                : [
                      { field: "timestamp", headerName: "Date & Time", minWidth: 220, flex: 1 },
                      { field: "id", headerName: "User ID", width: 350, hide: true, flex: 1 }, // Hide if `showUserIdCol` is false
                      { field: "interaction_id", headerName: "Interaction Id", minWidth: 200, flex: 1 },
                      { field: "index", headerName: "Index", hide: true },
                      { field: "pm_power_user", headerName: "PM Power User", minWidth: 200, flex: 1, filter: false }
                  ]
        );
    }, [showUserIdCol]);

    const defaultColDef: ColDef = {
        flex: 1,
        filter: true,
        editable: false,
        resizable: true
    };

    return (
        <div className={"ag-theme-quartz"} style={{ width: "100%", height: "100%" }}>
            <AgGridReact rowData={dislikeInteractionsData} columnDefs={colDefs} defaultColDef={defaultColDef} onCellClicked={onCellClicked} />
            {open && <ShowThreadResponse open={open} onCloseDialog={closeDrawerRight} selectedThreadId={selectedThreadId} checkBoxValue={checkBoxValue} />}
        </div>
    );
};
// We changed Like to useful and dislike to not useful
function LikeDislike() {
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [isDislikeInteractionsTableVisible, setIsDislikeInteractionsTableVisible] = useState(false);
    const [dislikeInteractionsData, setDislikeInteractionsData] = useState([]);
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [likeDislikeExportInteractionsData, setLikeDislikeExportInteractionsData] = useState([]);
    const [toggleChecked, setToggleChecked] = useState(false);
    const [checkBoxValue, setCheckBoxValue] = useState("");
    const [isLikeChecked, setIsLikeChecked] = useState(false);
    const [isDislikeChecked, setIsDislikeChecked] = useState(false);
    const [showUserIdCol, setShowUserIdCol] = useState(true);
    const navigate = useNavigate();
    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    async function handleAllInteractionsSubmitButton() {
        setIsDislikeInteractionsTableVisible(true);
        try {
            const allThreadResponse = await allInteractionsThreadsApi(formatDate(fromDate), formatDate(toDate));
            if (allThreadResponse.status === 401 || allThreadResponse.status === 422) {
                delete_user_data_from_client_side();
                navigate("/user_login");
            }

            const allThreadResponseInJson = await allThreadResponse.data;
            if (allThreadResponseInJson.admin) {
                setShowUserIdCol(true);
            } else {
                setShowUserIdCol(false);
            }
            const formattedData = allThreadResponseInJson.allInteractions.map((item: any, index: number) => {
                return {
                    timestamp: item.timestamp,
                    id: item.userId,
                    interaction_id: item.interactionId,
                    // prompt: "",
                    // index: "",
                    // like_dislike: "",
                    pm_power_user: item.pmPowerUser
                };
            });
            setOpen(false);
            setDislikeInteractionsData(formattedData);
        } catch (error) {
            errorToast(ErrorMessages[ErrorType.WENT_WRONG]);
        }
    }
    async function handleLikeDislikeSubmitButton(checkedValue: string) {
        setIsDislikeInteractionsTableVisible(true);
        try {
            const dislikeThreadResponse = await allLikeDislikedThreadsApi(formatDate(fromDate), formatDate(toDate), checkedValue);
            if (dislikeThreadResponse.status === 401 || dislikeThreadResponse.status === 422) {
                delete_user_data_from_client_side();
                navigate("/user_login");
            }

            const dislikeThreadResponseInJson = await dislikeThreadResponse.data;
            if (dislikeThreadResponseInJson.admin) {
                setShowUserIdCol(true);
            } else {
                setShowUserIdCol(false);
            }
            const formattedData = dislikeThreadResponseInJson.allInteractions.map((item: any, index: number) => {
                return {
                    // SNo: index + 1,
                    timestamp: item.timestamp,
                    id: item.userId,
                    interaction_id: item.interactionId,
                    // prompt: item.prompt,
                    // index: item.index,
                    like_dislike: item.feedback,
                    pm_power_user: item.pmPowerUser
                };
            });
            setOpen(false);
            setDislikeInteractionsData(formattedData);
        } catch (error) {
            errorToast(ErrorMessages[ErrorType.WENT_WRONG]);
        }
    }
    const validateDates = () => {
        if (fromDate > toDate) {
            setSubmitButtonDisabled(true);
            return false;
        }
        setSubmitButtonDisabled(false);
        return true;
    };
    return (
        <div>
            <div className="m-1  text-center flex flex-col min-w-96">
                <strong className=" font-bold text-2xl	">User Interactions (Useful / Not useful / All)</strong>
                <div className="px-11">
                    <div className="py-3">
                        <span>View a list of interactions (useful / not useful / all) for a given period.</span>
                    </div>
                    <div className=" flex w-full justify-center py-2">
                        <div className=" flex flex-wrap	gap-4 ">
                            <DatePeriodSelection toDate={toDate} fromDate={fromDate} setToDate={setToDate} setFromDate={setFromDate}></DatePeriodSelection>

                            <div className="flex gap-4 justify-center 	">
                                <div>
                                    <Button
                                        variant="text"
                                        className="min-w-36 h-10 font-medium bg-blue-400 text-white px-2"
                                        onClick={() => {
                                            if (isDislikeChecked && isLikeChecked) {
                                                handleLikeDislikeSubmitButton("");
                                            } else if (isDislikeChecked) {
                                                handleLikeDislikeSubmitButton("bad");
                                            } else if (isLikeChecked) {
                                                handleLikeDislikeSubmitButton("good");
                                            } else {
                                                handleAllInteractionsSubmitButton();
                                            }
                                        }}
                                        disabled={submitButtonDisabled}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                            <div className="inline-flex items-center gap-1 ml-10">
                                <label className={` ${toggleChecked === false ? "font-extrabold" : ""} text-slate-600 text-sm cursor-pointer font-bold`}>
                                    Useful
                                </label>

                                <div className="relative inline-block w-11 h-5">
                                    <input
                                        type="checkbox"
                                        className=" w-11 h-5 bg-slate-300 rounded-full checked:bg-green-800 cursor-pointer transition-colors duration-300"
                                        onChange={e => {
                                            if (e.target.checked === false) {
                                                setIsLikeChecked(false);
                                                if (isDislikeChecked) {
                                                    setCheckBoxValue("bad");
                                                    handleLikeDislikeSubmitButton("bad");
                                                } else {
                                                    setCheckBoxValue("");
                                                    handleAllInteractionsSubmitButton();
                                                }
                                            } else {
                                                setIsLikeChecked(true);
                                                if (isDislikeChecked) {
                                                    setCheckBoxValue("bothChecked");
                                                    handleLikeDislikeSubmitButton("");
                                                } else {
                                                    setCheckBoxValue("good");
                                                    handleLikeDislikeSubmitButton("good");
                                                }
                                            }
                                        }}
                                    />
                                </div>

                                <label className={` ${toggleChecked === true ? "font-extrabold" : ""}text-slate-600 text-sm cursor-pointer font-bold`}>
                                    Not useful
                                </label>
                                <div className="relative inline-block w-11 h-5">
                                    <input
                                        type="checkbox"
                                        className=" w-11 h-5 bg-slate-300 rounded-full checked:bg-green-800 cursor-pointer transition-colors duration-300"
                                        onChange={e => {
                                            if (e.target.checked === false) {
                                                setIsDislikeChecked(false);
                                                if (isLikeChecked) {
                                                    setCheckBoxValue("good");
                                                    handleLikeDislikeSubmitButton("good");
                                                } else {
                                                    setCheckBoxValue("");
                                                    handleAllInteractionsSubmitButton();
                                                }
                                            } else {
                                                setIsDislikeChecked(true);
                                                if (isLikeChecked) {
                                                    setCheckBoxValue("bothChecked");
                                                    handleLikeDislikeSubmitButton("");
                                                } else {
                                                    setCheckBoxValue("bad");
                                                    handleLikeDislikeSubmitButton("bad");
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>{" "}
                    </div>
                </div>
            </div>
            <div className="h-[70vh]">
                {isDislikeInteractionsTableVisible && (
                    <DislikeInteractionsThread
                        dislikeInteractionsData={dislikeInteractionsData}
                        open={open}
                        setOpen={setOpen}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        checkBoxValue={checkBoxValue}
                        showUserIdCol={showUserIdCol}
                    ></DislikeInteractionsThread>
                )}
            </div>
            <ToastContainer toastStyle={{ marginTop: "8vh" }} />
        </div>
    );
}

export default LikeDislike;
